import { Tabs } from 'antd';
import { useRequest } from 'ahooks';
import TabChildren from './components/TabChildren.js';
import './index.less';
import { getOrderCount } from '@/services/supplyChainFinance';
import { getCount } from '@/utils/utils';

export default function Index() {
  const { run, data } = useRequest(() => getOrderCount({}));

  const items = [
    { label: `待确认（${getCount(data?.pending)}）`, key: '0', children: <TabChildren tabKey="0" reset={run} /> },
    { label: `确认通过（${getCount(data?.approval)}）`, key: '1', children: <TabChildren tabKey="1" /> },
    { label: `确认不通过（${getCount(data?.refuse)}）`, key: '2', children: <TabChildren tabKey="2" /> },
  ];

  return (
    <div className="supply-chain-finance__order">
      {/* <div className="supply-chain-finance__banner">
        产业链金融
      </div> */}
      <div className="content-width">
        <div className="supply-chain-finance__info-title">产业链关系确认</div>
        <div className="margin-top20">
          <Tabs items={items} />
        </div>
      </div>
    </div>

  );
}
